import { useQuery } from "@tanstack/react-query";
import { PatientControllerApi } from "../services";
import { getConfigObject } from "../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useGetPatientProfile = (xTENANTID?: string | null) => {
  return useQuery({
    queryKey: ["patient-profile-by-tenantId"],
    queryFn: async () =>
      new PatientControllerApi(getConfigObject())
        .getProfile2(xTENANTID ?? undefined)
        .then((res) => res?.data),
  });
};
